// extracted by mini-css-extract-plugin
export default {"button":"Button_button__zXUCI","disabled":"Button_disabled__Ks4AM","withPadding":"Button_withPadding__E1bXD","primary":"Button_primary__7Ucgz"};